import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Optional,
	Output,
	SimpleChanges
} from "@angular/core";
import { HotKeysService } from "../../../../hotkeys/services/hotkeys.service";

@Component({
	selector: 'cp-popup',
	styles:['.is-hidden{display:none}'],
	template: `
		<div [class.is-hidden]="show === false">
			<ng-template #content><ng-content></ng-content></ng-template>

			<cp-resizable-popup *ngIf="resizable"
								[label]="label"
								[labelParam]="labelParam"
								[labelPlain]="labelPlain"
								[height]="height"
								[width]="width"
								[minHeight]="minHeight"
								[minWidth]="minWidth"
								[show]="show"
								[resizable]="resizable"
								[draggable]="draggable"
								[disposable]="disposable"
								[contentPadding]="contentPadding"
								[isModal]="isModal"
								(close)="close.emit($event)"
								[positionToken]="positionToken"
								[spinner]="spinner"
								(developerOptionsClick)="developerOptionsClick.emit($event)">
				<ng-container *ngTemplateOutlet="content"></ng-container>
			</cp-resizable-popup>

			<cp-static-popup *ngIf="!resizable"
							 [label]="label"
							 [labelParam]="labelParam"
							 [labelPlain]="labelPlain"
							 [height]="height"
							 [width]="width"
							 [minHeight]="minHeight"
							 [minWidth]="minWidth"
							 [autoHeight]="autoHeight"
							 [autoHeightAutoReCalc]="autoHeightAutoReCalc"
							 [show]="show"
							 [draggable]="draggable"
							 [disposable]="disposable"
							 [contentPadding]="contentPadding"
							 [isModal]="isModal"
							 (close)="close.emit($event)"
							 [positionToken]="positionToken"
							 [spinner]="spinner"
							 (developerOptionsClick)="developerOptionsClick.emit($event)">
				<ng-container *ngTemplateOutlet="content"></ng-container>
			</cp-static-popup>
		</div>
	`
})
export class PopupComponent implements OnInit, OnDestroy, OnChanges {
	@Input() label;
	@Input() labelParam: string;
	@Input() labelPlain:string; // labelPlain is label without translation
	@Input() disposable = true;
	@Input() isModal=true;

	@Output() close = new EventEmitter();
	@Output() developerOptionsClick = new EventEmitter();

	@Input() width: string;
	@Input() height: string;

	@Input() minHeight: string;
	@Input() minWidth: string;

	@Input() show: boolean;

	@Input() autoHeight: boolean;
	@Input() autoHeightAutoReCalc: boolean;

	@Input() draggable: boolean;
	@Input() resizable: boolean;

	@Input() contentPadding: boolean = true;
	@Input() keepHotKeys=false;

	//this is a placeholder for when we set the location last used by user
	@Input() positionToken:string;

	@Input() spinner: boolean;

	private disabledHotKeys=true;

	constructor(private hotKeyService:HotKeysService,) {
	}
	ngOnInit() {
		if (!this.keepHotKeys && this.show!==false){
			this.disableHotKeys();
		}
		if (this.resizable && this.autoHeight) {
			throw new Error('Popup can be either resizable OR autoHeight');
		}
	}
	ngOnDestroy(): void {
		this.enableHotKeys();
	}

	ngOnChanges(changes: SimpleChanges): void {
		let showChanges=changes["show"];
		if (!this.keepHotKeys && showChanges){
			if (showChanges.currentValue!==false && showChanges.previousValue===false){
				this.disableHotKeys();
			}else if (showChanges.currentValue===false &&showChanges.previousValue!==false){
				this.enableHotKeys();
			}
		}
	}
	private enableHotKeys(){
		if (this.disabledHotKeys){
			// bug if someone else disabled it and not the popup?
			this.hotKeyService.enableHotKeys();
			this.disabledHotKeys=false;
		}
	}
	private disableHotKeys(){		
		this.hotKeyService.disableHotKeys();
	
		this.disabledHotKeys=true;
	}
}
